// Generated by purs version 0.13.8
"use strict";
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_Maybe_Trans = require("../Control.Monad.Maybe.Trans/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Effect = require("../Effect/index.js");
var Effect_Class = require("../Effect.Class/index.js");
var Record = require("../Record/index.js");
var Specular_FRP_Base = require("../Specular.FRP.Base/index.js");
var Specular_FRP_Replaceable = require("../Specular.FRP.Replaceable/index.js");
var Specular_FormField = require("../Specular.FormField/index.js");
var Specular_Ref = require("../Specular.Ref/index.js");
var Type_Data_RowList = require("../Type.Data.RowList/index.js");
var Type_Equality = require("../Type.Equality/index.js");
var SwitchRecord = function (switchRecord) {
    this.switchRecord = switchRecord;
};
var Switch = function ($$switch) {
    this["switch"] = $$switch;
};
var switchRecordNil = function (dictTypeEquals) {
    return new SwitchRecord(function (v) {
        return function (v1) {
            return Type_Equality.to(dictTypeEquals)({});
        };
    });
};
var switchRecord = function (dict) {
    return dict.switchRecord;
};
var switchRecordI = function (dictSwitchRecord) {
    return function (dictRowToList) {
        return new Switch(switchRecord(dictSwitchRecord)(Type_Data_RowList.RLProxy.value));
    };
};
var switchFinal = new Switch((function () {
    var $17 = Control_Bind.join(Specular_FRP_Base.bindDynamic);
    var $18 = Data_Functor.map(Specular_FRP_Base.functorDynamic)(Specular_FormField.unFinal);
    return function ($19) {
        return Specular_FormField.Final(Control_Monad_Maybe_Trans.MaybeT($17($18($19))));
    };
})());
var switchEvent = new Switch(Specular_FRP_Base["switch"]);
var switchEffect = new Switch((function () {
    var $20 = Control_Bind.join(Effect.bindEffect);
    var $21 = Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect);
    return function ($22) {
        return $20($21($22));
    };
})());
var switchDynamic = new Switch(Control_Bind.join(Specular_FRP_Base.bindDynamic));
var $$switch = function (dict) {
    return dict["switch"];
};
var switchFunction = function (dictSwitch) {
    return new Switch(function (f) {
        return function (x) {
            return $$switch(dictSwitch)(Data_Functor.map(Specular_FRP_Base.functorDynamic)(function (v) {
                return v(x);
            })(f));
        };
    });
};
var switchRecordCons = function (dictIsSymbol) {
    return function (dictLacks) {
        return function (dictCons) {
            return function (dictSwitch) {
                return function (dictSwitchRecord) {
                    return function (dictCons1) {
                        return new SwitchRecord(function (v) {
                            return function (dyn) {
                                return Record.insert(dictIsSymbol)()()(Data_Symbol.SProxy.value)($$switch(dictSwitch)(Data_Functor.map(Specular_FRP_Base.functorDynamic)(Record.get(dictIsSymbol)()(Data_Symbol.SProxy.value))(dyn)))(switchRecord(dictSwitchRecord)(Type_Data_RowList.RLProxy.value)(dyn));
                            };
                        });
                    };
                };
            };
        };
    };
};
var switchRef = new Switch(function (dyn) {
    return new Specular_Ref.Ref($$switch(switchDynamic)(Data_Functor.map(Specular_FRP_Base.functorDynamic)(Specular_Ref.value)(dyn)), $$switch(switchFunction(switchEffect))(Data_Functor.map(Specular_FRP_Base.functorDynamic)(Specular_Ref.modify(Effect_Class.monadEffectEffect))(dyn)));
});
var dynamicSwitch = function (dictSwitch) {
    return function (dictMonadReplace) {
        return function (dictMonadFRP) {
            var $23 = Data_Functor.map(((((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1()).Apply0()).Functor0())($$switch(dictSwitch));
            var $24 = Specular_FRP_Replaceable.dynamic(dictMonadReplace)(dictMonadFRP);
            return function ($25) {
                return $23($24($25));
            };
        };
    };
};
module.exports = {
    Switch: Switch,
    "switch": $$switch,
    dynamicSwitch: dynamicSwitch,
    SwitchRecord: SwitchRecord,
    switchRecord: switchRecord,
    switchDynamic: switchDynamic,
    switchEvent: switchEvent,
    switchEffect: switchEffect,
    switchFunction: switchFunction,
    switchRef: switchRef,
    switchFinal: switchFinal,
    switchRecordI: switchRecordI,
    switchRecordNil: switchRecordNil,
    switchRecordCons: switchRecordCons
};
//# sourceMappingURL=index.js.map
